module.exports = __webpack_public_path__ + "media/audiosprite.9e4b6daa.mp3";